import { lazy } from "react";
import { RouteObject } from "react-router-dom";

const CreateSubscription = lazy (
    () => import('../components/SubscriptionUpsert')
);
const CreateSubscriptionRoute: RouteObject = {
  path: 'create-subscription',
  element: <CreateSubscription />,  
}
const EditSubscriptionRoute: RouteObject = {
  path: 'subscriptions/:id',
  element: <CreateSubscription />,  
}
export {CreateSubscriptionRoute,EditSubscriptionRoute};